/* tslint:disable */
/* eslint-disable */
/**
 * The Thing API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CollectionItem
 */
export interface CollectionItem {
    /**
     * 
     * @type {number}
     * @memberof CollectionItem
     */
    number?: number;
    /**
     * 
     * @type {string}
     * @memberof CollectionItem
     */
    text?: string | null;
}

export function CollectionItemFromJSON(json: any): CollectionItem {
    return CollectionItemFromJSONTyped(json, false);
}

export function CollectionItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): CollectionItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'number': !exists(json, 'number') ? undefined : json['number'],
        'text': !exists(json, 'text') ? undefined : json['text'],
    };
}

export function CollectionItemToJSON(value?: CollectionItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'number': value.number,
        'text': value.text,
    };
}


